import { DateTime } from "luxon";

const DISPLAY_FORMAT = "MMM dd, yyyy";

type ShipmentDateRange = {
  startDate: string | undefined;
  endDate: string | undefined;
};

const parseRangeDate = (date: string | undefined) => {
  const parsed = date ? DateTime.fromISO(date, { zone: "utc" }) : undefined;
  return parsed?.isValid ? parsed : undefined;
};

/** Label for a closed shipment date range; null unless both dates are set. */
export const formatShipmentRangeDate = ({ startDate, endDate }: ShipmentDateRange) => {
  const start = parseRangeDate(startDate);
  const end = parseRangeDate(endDate);
  if (!start || !end) return null;
  return `${start.toFormat(DISPLAY_FORMAT)} - ${end.toFormat(DISPLAY_FORMAT)}`;
};

/**
 * Label for the stream drawer, whose data accepts an open range: a missing
 * date leaves that side open, and no date covers every shipment. The facility
 * tiles need both dates, so they use formatShipmentRangeDate.
 */
export const formatOpenShipmentRangeDate = (range: ShipmentDateRange) => {
  const closed = formatShipmentRangeDate(range);
  if (closed) return closed;
  const start = parseRangeDate(range.startDate);
  if (start) return `From ${start.toFormat(DISPLAY_FORMAT)}`;
  const end = parseRangeDate(range.endDate);
  if (end) return `Through ${end.toFormat(DISPLAY_FORMAT)}`;
  return "All dates";
};
